import { useEffect } from "react";

const useScrollTop = (page) => {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const mainScrollable = document.querySelector(".bar.bar-auto-hide");

    const target = mainScrollable || window;

    if ("scrollTo" in target) {
      target.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    } else if (target === window) {
      window.scroll(0, 0);
    }
  }, [page]);
};

export default useScrollTop;
